<!--
	AuthSearchBar.svelte

    Contains:
    
        <Textfield>         // ZIP Code
        <Textfield>         // free text
        <SearchIcon>        // magnifying glass

    All surrounded by an oval outline.
-->

<script>

    import { onMount } from 'svelte';
	import { isRunningSearch, isShowingSearchOptions, isShowingSearchResults } from '../../stores/ScreenSettingsStore';
	import { setErrorAlert, setWarningAlert, clearAlert } from '../../stores/AlertsStore';
    
    // SMUI components
    import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiMagnify } from '@mdi/js';

    export let store;                                               // Search object - $masterSearch

    const LABEL_POSTAL = 'ZIP Code';
    const LABEL_FREE_TEXT = 'Enter search text';

    const POSTAL_WARNING_MSG = 'Please enter a valid ZIP Code.';
    const SEARCH_ERROR_MSG = 'We\'re sorry - an error occurred during your search.';

    onMount(() => {
        // console.log('');
        // console.log('AuthSearchBar onMount');
        // console.log('$store:');
        // console.log($store);
    })

    const onTextfieldClick = (e) => {
        clearAlert();
    }

    const onTextFieldKeyup = (e) => {
        if (e.key == 'Enter') {
            onSearchClick();
        }
    }
    
    // this is the main ZIP Code search - no filters
    const onSearchClick = async () => {
        let postal = $store.location.postalCode;
        if (postal === '' || (postal.length != 5 && postal.length != 10)) {
            setWarningAlert(POSTAL_WARNING_MSG, 1000);
            return;
        }

        clearAlert();

        $isRunningSearch = true;
        let results = await $store.runSearch(50);       // Search object will call the API            
        $isRunningSearch = false;
        
        if (results.errors)  {
            setErrorAlert(SEARCH_ERROR_MSG, 1000);
        } else {
            $store = $store;                            // MUST RESET THE STORE TO TRIGGER UI!
            $isShowingSearchOptions = false;
            $isShowingSearchResults = true;
        }
    }

</script>


<style>
    .auth-search-bar {
        width: fit-content;
        padding: 5px 5px 5px 25px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        border: 1px solid var(--tcare-field-bg-readonly);
        border-radius: 30px;
    }

    :global(.search-text-input) {
        margin-right: 20px;
        font-size: 15px;
        padding: 5px;
        color: var(--tcare-primary);
        border: none;
        border-bottom: 1px solid var(--tcare-field-bg-readonly);
    }    

    :global(.search-text-input.postal) {
        width: 90px;
    }    

    :global(.search-text-input.free-text) {
        width: 160px;
    }    


    .search-icon {
        width: 34px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        user-select: none;
        background-color: var(--tcare-light-purple);
        border-radius: 50%;
    }

    :global(.search-icon svg) {
        width: 65%;
        height: 65%;
        fill: var(--tcare-purple);
        outline: none;
    }

    .search-icon:hover {
        background-color: var(--tcare-secondary);
    }

    /* this works for child CSS! */
    :global(.search-icon:hover svg) {
        fill: var(--tcare-white);
    }

    .is-searching {
        font-size: 16px;
        /* font-weight: 800; */
        padding: 6px 20px;
        color: var(--tcare-purple);
    }

    /* if not showing magnifying glass */
    .spacer-20 {
        width: 20px;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }
</style>


<div class="auth-search-bar">
    {#if $isRunningSearch}
        <div class="is-searching">Searching for resources in {$store.location.postalCode}</div>
        <!-- need to pad right extra if no magnifying glass -->
        <div class="spacer-20"></div>
    {:else}
        <input class="search-text-input postal"
            placeholder={LABEL_POSTAL}
            bind:value={$store.location.postalCode}
            on:click={onTextfieldClick}
            on:keyup={onTextFieldKeyup}
        />

        <input class="search-text-input free-text"
            placeholder={LABEL_FREE_TEXT}
            bind:value={$store.text}
            on:click={onTextfieldClick}
            on:keyup={onTextFieldKeyup}
        />

        <div class="search-icon" on:click={onSearchClick}>
            <Icon component={Svg} viewBox="0 0 24 24">
                <path d={mdiMagnify}/>
            </Icon>
        </div>
    {/if}
</div>
